/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { defineMessages } from 'react-intl';

import { fetchGet, fetchPut, fetchDelete, fetchPost } from 'FetchAPIs';
import { I18NError } from 'Utils';

const messages = defineMessages({
  serviceError: 'An error occurred while fetching the services. {message}',
  deleteError: 'An error occurred while deleting the service. {message}',
  addError: 'An error occurred while adding the service. {message}',
  updateError: 'An error occurred while updating the service. {message}',
});

const BASE_API_URL = '/api/tenants';
const METADATA_API_URL = `/api/hierarchies/tenant/metadata`;

export const getActiveServices = () => fetchGet(`${BASE_API_URL}/active-services`);

// Table view APIs
export const getMetadata = () =>
  fetchGet(METADATA_API_URL).catch(error => {
    throw new I18NError(messages.serviceError, error);
  });

export const deleteMetadata = id =>
  fetchDelete(METADATA_API_URL, id).catch(error => {
    throw new I18NError(messages.deleteError, error);
  });

export const addMetadata = metadata =>
  fetchPost(METADATA_API_URL, metadata).catch(error => {
    throw new I18NError(messages.addError, error);
  });

export const updateMetadata = metadata =>
  fetchPut(METADATA_API_URL, metadata).catch(error => {
    throw new I18NError(messages.updateError, error);
  });
